/*! OnlyPlanks motion — colour pill crossfade (no loops) */
(function () {
  if (window.__opMotionBound) return;
  window.__opMotionBound = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  function galleryRoot() {
    return (
      document.querySelector('.product-information media-gallery') ||
      document.querySelector('media-gallery') ||
      document.querySelector('.product-information .product-media-container')
    );
  }

  function fadeOut(el) {
    el.classList.add('op-media-fading');
  }

  function fadeIn(el) {
    el.classList.remove('op-media-fading');
    el.classList.add('op-media-faded-in');
    window.setTimeout(function () {
      el.classList.remove('op-media-faded-in');
    }, 320);
  }

  var pending = false;
  var observer = null;
  var safetyTimer = null;

  function armReveal(el) {
    if (observer) {
      try { observer.disconnect(); } catch (e) {}
      observer = null;
    }
    if (safetyTimer) {
      window.clearTimeout(safetyTimer);
      safetyTimer = null;
    }

    var revealed = false;
    function reveal() {
      if (revealed) return;
      revealed = true;
      pending = false;
      if (observer) {
        try { observer.disconnect(); } catch (e) {}
        observer = null;
      }
      if (safetyTimer) {
        window.clearTimeout(safetyTimer);
        safetyTimer = null;
      }
      fadeIn(el);
    }

    observer = new MutationObserver(function () {
      // Media morph finished — wait a tick for img paint
      window.setTimeout(reveal, 40);
    });
    observer.observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });

    // Fallback if morph is instant / already done
    safetyTimer = window.setTimeout(reveal, 450);
  }

  function onVariantIntent(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    // Colour / size radios or swatch labels inside variant-picker
    var picker = t.closest('variant-picker');
    if (!picker) return;
    if (picker.closest('product-card')) return; // skip collection quick-add cards

    var el = galleryRoot();
    if (!el) return;
    if (pending) return;
    pending = true;
    fadeOut(el);
    armReveal(el);
  }

  // capture so we run before Horizon morph
  document.addEventListener('pointerdown', onVariantIntent, true);
  document.addEventListener('change', onVariantIntent, true);
})();
